import {
  List,
  ListItemButton,
  ListItemText,
  Stack,
  ListItem,
  Typography,
} from '@mui/material';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { DropdownItem } from 'types/header';

export const SubMenuItem = ({
  item,
  showBorder,
}: // closeMenu,
{
  item: DropdownItem;
  showBorder: boolean;
  closeMenu: () => void;
}) => {
  const smartNavigate = useSmartNavigate();
  const baseUrlFederlegno = process.env.REACT_APP_FEDERLEGNOARREDO;
  // const baseUrl = process.env.REACT_APP_DRUPAL_BASE_URL;

  return (
    <ListItem key={item.path} disableGutters>
      <Stack
        sx={{
          width: '100%',
          py: 4,
          borderBottom: theme =>
            showBorder ? `1px solid ${theme.palette.grey[400]}` : undefined,
        }}
      >
        <Typography variant="body1" color={'grey.600'}>
          {item.title}
        </Typography>
        <List>
          {item.children?.map(child => (
            <ListItem key={child.path} disablePadding>
              <ListItemButton
                disableRipple
                disableTouchRipple
                onClick={() => {
                  if (child.path)
                    smartNavigate(`${baseUrlFederlegno}${child.path}`);
                  //closeMenu();
                }}
                disableGutters
                sx={{
                  maxWidth: '100%',
                  overflow: 'hidden',
                }}
              >
                <ListItemText
                  primary={child.title}
                  secondary={child.subtitle}
                  primaryTypographyProps={{
                    variant: 'body1',
                    fontSize: 24,
                    fontWeight: 600,
                    sx: {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      maxWidth: '100%',
                    },
                  }}
                  secondaryTypographyProps={{
                    sx: {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      maxWidth: '100%',
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Stack>
    </ListItem>
  );
};
